module.exports = __webpack_public_path__ + "img/eliminate.c3eeffa5.gif";